export default class Payment {
    pay_type: string;
    cc_number: string;
    cc_type: string;
    expire_month: number;
    expire_year: number;
    card_cvv2: string;
    constructor() {
        //this.pay_type = 'card';
        this.pay_type = 'bank';
        this.cc_number = '';
        this.cc_type = '';
        this.expire_month = 0;
        this.expire_year = 0;
        this.card_cvv2 = '';
    }
}